export const EmojiSuper = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <g clip-path="url(#clip0_5246_190096)">
      <g filter="url(#filter0_f_5246_190096)">
        <path
          fill="#C2DEE4"
          d="M60.97 62.776c0-.07-.183-.139-.538-.205-3.277-.436-13.694-.75-26.035-.75-14.977 0-27.124.468-27.124 1.043 0 .07.184.14.539.205 3.289.436 13.694.751 26.035.751 14.977 0 27.124-.469 27.124-1.044Z"
        />
      </g>
      <g filter="url(#filter1_f_5246_190096)">
        <path
          fill="url(#paint0_radial_5246_190096)"
          d="M52.257 15.785c-1.392 2.496-.346 5.491 2.796 6.475s6.026-1.055 6.439-4.926c.227-2.13-1.092-4.311-1.59-4.902.25.796.35 2.048-.224 2.813-.574.764-1.563 1.03-2.007.892.902-1.093.946-2.75.592-4.125-.34-1.322-1.16-2.326-2.202-3.334.542 1.483.442 2.677-.382 3.78-.93 1.243-2.23 1.191-3.422 3.327Z"
        />
      </g>
      <g filter="url(#filter2_f_5246_190096)">
        <path
          fill="url(#paint1_radial_5246_190096)"
          d="M4.502 17.805c.665 4.495 4.888 7.255 9.802 5.448 4.914-1.807 6.57-7.174 3.336-12.452-1.78-2.903-5.557-4.374-6.758-4.633 1.088.758 2.427 2.24 2.446 3.76.018 1.52-.97 2.815-1.663 3.07.077-2.251-1.475-4.383-3.255-5.772C6.7 5.891 4.693 5.422 2.403 5.161c2.12 1.343 3.153 2.944 3.184 5.133.034 2.468-1.655 3.664-1.085 7.511Z"
        />
      </g>
      <mask
        id="mask0_5246_190096"
        width="45"
        height="45"
        x="12"
        y="6"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <circle cx="34.257" cy="28.031" r="21.984" fill="#fff" />
      </mask>
      <g mask="url(#mask0_5246_190096)">
        <circle cx="34.257" cy="28.031" r="21.984" fill="#D9D9D9" />
        <circle
          cx="34.257"
          cy="28.031"
          r="21.984"
          fill="url(#paint2_radial_5246_190096)"
        />
        <circle
          cx="34.257"
          cy="28.031"
          r="21.984"
          fill="url(#paint3_linear_5246_190096)"
        />
        <g filter="url(#filter3_biif_5246_190096)">
          <path
            fill="#FA552D"
            d="M15.935 42.064c.349-2.452 3.55-5.726 6.719-4.475 5.15 2.035 4.557 9.62-.78 16.17-8.44.444-14.914-3.552-13.516-8.91.86-3.298 5.391-3.95 7.577-2.785Z"
          />
        </g>
        <g filter="url(#filter4_f_5246_190096)">
          <ellipse
            cx="20.974"
            cy="30.515"
            fill="url(#paint4_radial_5246_190096)"
            rx="5.694"
            ry="5.679"
          />
        </g>
        <g filter="url(#filter5_f_5246_190096)">
          <ellipse
            cx="45.931"
            cy="30.515"
            fill="url(#paint5_radial_5246_190096)"
            rx="5.694"
            ry="5.679"
          />
        </g>
        <g filter="url(#filter6_f_5246_190096)">
          <path
            fill="#C73512"
            d="M46.78 44.803c5.555-4.304 6.742-8.576 7.569-14.549-1.768 7.06-4.959 10.322-9.546 13.638-5.287 3.822-9.88 4.374-17.658 3.659 6.82 1.74 13.781 1.787 19.634-2.748Z"
          />
        </g>
        <g filter="url(#filter7_f_5246_190096)" opacity=".8">
          <path
            fill="#0057D6"
            d="M36.547 50.268c.612 1.612 2.607 6.627 5.456 9.62 1.832 1.924 5.01 3.436 7.093 3.26 2.254-.189 5.565-1.965 6.805-5.265l2.16-5.745c.753-2.002-1.069-3.7-2.378-2.377 1.06-2.822-1.894-3.864-2.728-1.645.994-2.645-2.206-4.381-3.376-1.27l2.94-7.821c.799-2.123-2.259-3.204-3.034-1.141l-5.03 13.38c-.352.934-.91 1.666-1.707 1.096-.91-.65-2.172-2.548-3.745-3.657-1.282-.903-3.069-.046-2.456 1.565Z"
          />
        </g>
        <g filter="url(#filter8_ii_5246_190096)">
          <path
            stroke="#050304"
            stroke-linecap="round"
            stroke-width="1.68"
            d="M27.717 34.906s1.186 3.048 6.434 3.048 6.434-3.048 6.434-3.048"
          />
        </g>
        <g filter="url(#filter9_d_5246_190096)">
          <ellipse
            cx="44.313"
            cy="21.78"
            fill="url(#paint6_radial_5246_190096)"
            rx="7.804"
            ry="8.266"
            transform="rotate(20 44.313 21.78)"
          />
        </g>
        <ellipse
          cx="48.852"
          cy="26.24"
          fill="#fff"
          rx=".754"
          ry="1.914"
          transform="rotate(44.325 48.852 26.24)"
        />
        <ellipse
          cx="45.318"
          cy="28.461"
          fill="#fff"
          rx=".406"
          ry="1.031"
          transform="rotate(77.674 45.318 28.46)"
        />
        <g filter="url(#filter10_d_5246_190096)">
          <ellipse
            cx="23.991"
            cy="21.785"
            fill="url(#paint7_radial_5246_190096)"
            rx="7.804"
            ry="8.266"
            transform="rotate(-20 23.99 21.785)"
          />
        </g>
        <circle cx="44.617" cy="19.602" r="2.5" fill="#171A1C" />
        <circle cx="23.617" cy="19.602" r="2.5" fill="#171A1C" />
        <ellipse
          cx="30.332"
          cy="22.278"
          fill="#fff"
          rx=".754"
          ry="1.914"
          transform="rotate(4.326 30.332 22.278)"
        />
        <ellipse
          cx="29.053"
          cy="26.259"
          fill="#fff"
          rx=".406"
          ry="1.031"
          transform="rotate(37.674 29.053 26.26)"
        />
      </g>
      <g filter="url(#filter11_ii_5246_190096)">
        <path
          fill="#fff"
          d="M33.922 46.292c.612 1.611 2.607 6.626 5.456 9.62 1.832 1.924 5.01 3.435 7.093 3.26 2.254-.19 5.565-1.965 6.805-5.265l2.16-5.746c.753-2.002-1.069-3.7-2.378-2.377 1.06-2.822-1.894-3.864-2.728-1.645.994-2.645-2.206-4.38-3.376-1.269l2.94-7.822c.799-2.122-2.259-3.204-3.034-1.14l-5.03 13.38c-.352.933-.91 1.666-1.707 1.096-.91-.65-2.172-2.548-3.745-3.657-1.282-.904-3.069-.046-2.456 1.565Z"
        />
      </g>
      <mask
        id="mask1_5246_190096"
        width="19"
        height="17"
        x="3"
        y="32"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path
          fill="#fff"
          d="M11.55 36.939c.349-2.452 3.55-5.726 6.719-4.475 5.151 2.035 4.557 9.62-.78 16.17-8.439.444-14.913-3.552-13.516-8.91.86-3.298 5.392-3.95 7.577-2.785Z"
        />
      </mask>
      <g mask="url(#mask1_5246_190096)">
        <g filter="url(#filter12_bii_5246_190096)">
          <path
            fill="#FA552D"
            d="M11.55 36.939c.349-2.452 3.55-5.726 6.719-4.475 5.151 2.035 4.557 9.62-.78 16.17-8.439.444-14.913-3.552-13.516-8.91.86-3.298 5.392-3.95 7.577-2.785Z"
          />
        </g>
        <g filter="url(#filter13_f_5246_190096)">
          <circle cx="34.259" cy="28.031" r="21.984" fill="#E82833" />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_5246_190096"
        width="56.27"
        height="4.573"
        x="5.987"
        y="60.534"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190096"
          stdDeviation=".643"
        />
      </filter>
      <filter
        id="filter1_f_5246_190096"
        width="12.116"
        height="16.079"
        x="50.527"
        y="7.554"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190096"
          stdDeviation=".563"
        />
      </filter>
      <filter
        id="filter2_f_5246_190096"
        width="19.157"
        height="20.9"
        x="1.277"
        y="4.038"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190096"
          stdDeviation=".563"
        />
      </filter>
      <filter
        id="filter3_biif_5246_190096"
        width="22.547"
        height="20.987"
        x="5.917"
        y="35.061"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation=".563" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_5246_190096"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_5246_190096"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx=".338" dy=".338" />
        <feGaussianBlur stdDeviation=".281" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.996078 0 0 0 0 1 0 0 0 0 0.811765 0 0 0 1 0" />
        <feBlend in2="shape" result="effect2_innerShadow_5246_190096" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.338" dy="-.338" />
        <feGaussianBlur stdDeviation=".281" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.883333 0 0 0 0 0.308799 0 0 0 0 0.0625694 0 0 0 1 0" />
        <feBlend
          in2="effect2_innerShadow_5246_190096"
          result="effect3_innerShadow_5246_190096"
        />
        <feGaussianBlur
          result="effect4_foregroundBlur_5246_190096"
          stdDeviation="1.126"
        />
      </filter>
      <filter
        id="filter4_f_5246_190096"
        width="17.017"
        height="16.987"
        x="12.465"
        y="22.022"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190096"
          stdDeviation="1.407"
        />
      </filter>
      <filter
        id="filter5_f_5246_190096"
        width="17.017"
        height="16.987"
        x="37.422"
        y="22.022"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190096"
          stdDeviation="1.407"
        />
      </filter>
      <filter
        id="filter6_f_5246_190096"
        width="31.707"
        height="22.885"
        x="24.893"
        y="28.007"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190096"
          stdDeviation="1.126"
        />
      </filter>
      <filter
        id="filter7_f_5246_190096"
        width="26.319"
        height="30.885"
        x="34.171"
        y="34.53"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190096"
          stdDeviation="1.126"
        />
      </filter>
      <filter
        id="filter8_ii_5246_190096"
        width="16.237"
        height="5.86"
        x="26.314"
        y="33.5"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy=".563" />
        <feGaussianBlur stdDeviation=".563" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.980392 0 0 0 0 0.333333 0 0 0 0 0.176471 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190096" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.563" dy="-.563" />
        <feGaussianBlur stdDeviation=".563" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.839216 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190096"
          result="effect2_innerShadow_5246_190096"
        />
      </filter>
      <filter
        id="filter9_d_5246_190096"
        width="25.855"
        height="26.56"
        x="32.512"
        y="10.186"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy="1.688" />
        <feGaussianBlur stdDeviation="2.533" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.970833 0 0 0 0 0.619202 0 0 0 0 0.533958 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5246_190096"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5246_190096"
          result="shape"
        />
      </filter>
      <filter
        id="filter10_d_5246_190096"
        width="25.855"
        height="26.56"
        x="12.189"
        y="10.194"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy="1.688" />
        <feGaussianBlur stdDeviation="2.533" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.972549 0 0 0 0 0.619608 0 0 0 0 0.533333 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5246_190096"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5246_190096"
          result="shape"
        />
      </filter>
      <filter
        id="filter11_ii_5246_190096"
        width="25.193"
        height="26.946"
        x="32.671"
        y="32.242"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-1.126" />
        <feGaussianBlur stdDeviation="1.407" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.504167 0 0 0 0 0.805687 0 0 0 0 1 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_5246_190096" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="2.251" dy="-.563" />
        <feGaussianBlur stdDeviation="1.688" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.972 0 0 0 0 1 0 0 0 0 0.8 0 0 0 1 0" />
        <feBlend
          in2="effect1_innerShadow_5246_190096"
          result="effect2_innerShadow_5246_190096"
        />
      </filter>
      <filter
        id="filter12_bii_5246_190096"
        width="20.296"
        height="18.736"
        x="2.658"
        y="31.062"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation=".563" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_5246_190096"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_5246_190096"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx=".338" dy=".338" />
        <feGaussianBlur stdDeviation=".281" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.996078 0 0 0 0 1 0 0 0 0 0.811765 0 0 0 1 0" />
        <feBlend in2="shape" result="effect2_innerShadow_5246_190096" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.338" dy="-.338" />
        <feGaussianBlur stdDeviation=".281" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.883333 0 0 0 0 0.308799 0 0 0 0 0.0625694 0 0 0 1 0" />
        <feBlend
          in2="effect2_innerShadow_5246_190096"
          result="effect3_innerShadow_5246_190096"
        />
      </filter>
      <filter
        id="filter13_f_5246_190096"
        width="46.218"
        height="46.22"
        x="11.15"
        y="4.921"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5246_190096"
          stdDeviation=".563"
        />
      </filter>
      <radialGradient
        id="paint0_radial_5246_190096"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(3.54887 -11.33063 4.73666 1.48357 55.11 22.278)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".235" stop-color="#FEFFCF" />
        <stop offset=".483" stop-color="#FFCA42" />
        <stop offset=".863" stop-color="#FA552D" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_5246_190096"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(-110.191 15.297 6.59) scale(18.8791 7.89218)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".235" stop-color="#FEFFCF" />
        <stop offset=".483" stop-color="#FFCA42" />
        <stop offset=".863" stop-color="#FA552D" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_5246_190096"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(43.657 -14.014 44.48) scale(32.7647 30.6393)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEFFCF" />
        <stop offset=".418" stop-color="#FFCA42" />
        <stop offset=".736" stop-color="#FFCF53" />
        <stop offset="1" stop-color="#FF8163" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_5246_190096"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 5.67932 -5.69444 0 20.974 30.515)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".36" stop-color="#FCC" />
        <stop offset="1" stop-color="#FCC" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_5246_190096"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 5.67932 -5.69444 0 45.93 30.515)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".36" stop-color="#FCC" />
        <stop offset="1" stop-color="#FCC" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_5246_190096"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -.906 58.977) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#D0EBFF" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_5246_190096"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -11.073 35.846) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#D0EBFF" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <linearGradient
        id="paint3_linear_5246_190096"
        x1="23.804"
        x2="37.392"
        y1="8.23"
        y2="27.456"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#FEFFCF" />
        <stop offset=".353" stop-color="#FEFFCF" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_5246_190096">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
);
